import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { startOfMonth, endOfMonth, isValid, addDays, setMonth } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Records } from '../../interfaces/records';
import { Stores } from '../../interfaces/stores';

@Component({
  selector: 'app-list-recors-facility',
  templateUrl: './list-recors-facility.component.html',
  styleUrls: ['./list-recors-facility.component.css']
})
export class ListRecorsFacilityComponent {
  @Input()
  facilityId:number;
  active:number=1;
}